module.exports = __webpack_public_path__ + "static/media/typescript-icon.9e8bfce4.svg";